var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    viewBox: "0 0 24 24",
    width: 480,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B43434",
    d: "M12 0C5.371 0 0 5.371 0 12s5.371 12 12 12 12-5.371 12-12S18.629 0 12 0zm0 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 3.813c-.184 0-.336-.004-.5.03-.164.036-.316.126-.438.22s-.21.222-.28.375c-.071.152-.095.332-.095.562 0 .227.024.406.094.563.07.156.16.28.281.375s.274.148.438.187c.164.04.316.063.5.063.18 0 .371-.024.531-.063.16-.04.285-.094.406-.188s.211-.218.282-.375c.07-.152.125-.335.125-.562 0-.23-.055-.41-.125-.563-.07-.152-.16-.28-.281-.375s-.247-.183-.407-.218-.351-.032-.531-.032zm-1.219 3.343v8.969h2.438V9.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b20c914a29a73b5e05fa1e6e75c6370a.svg";
export { ForwardRef as ReactComponent };